import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupTriggerDirective } from './popup-trigger.directive';

@NgModule({
  declarations: [
    PopupTriggerDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PopupTriggerDirective
  ]
})
export class PopupTriggerModule { }
